enum ItemType {
	CATEGORY = "CATEGORY",
	PRODUCT = "PRODUCT"
}

enum Parametrics {
	COLOR = "color",
	SIZE = "shirtsize"
}

enum PageSlugs {
	PRODUCT = "product",
	CATEGORY = "category",
	PRODUCT_PAGE = "product-page",
	BLOG = "blog",
	BLOG_CATEGORY = "blog-category",
	ARTICLE = "article"
}

enum ComponentsRenderedInModal {
	ACCOUNT_LOGIN_FORM = "account",
	ACCOUNT_SIGN_UP_FORM = "account",
	ACCOUNT_RECOVER_PASSWORD = "account",
	ACCOUNT_WISHLIST = "account",
	STORE_AVAILABILITY = "Product"
}

enum CategoryUrlParams {
	FILTER = "filter",
	SORT = "sort",
	PAGE = "pageNo"
}

enum ProductPrefix {
	PACKAGE_PRODUCT = "package-product",
	SIMILAR_PRODUCTS = "similar-products",
	RELATION_VARIANTS = "product-variants",
	MATCH_AND_BUY = "match-and-buy",
	/**
	 * Cross-sell relation shown under the gallery on the PDP ("Kombinera med").
	 * Matched by `matchesRelationPrefix`: the bare code or a `combine-` prefix,
	 * so `combine`, `combine-with` and `combine-1` resolve while `pre-combine`
	 * and `combined-offers` do not.
	 */
	COMBINE = "combine"
}

enum ProductTypes {
	BUNDLE = "ManagedStructure"
}

const BUNDLE_TYPE_NAMES = ["ManagedStructure", "Bundle"] as const;
const isBundleProductTypeName = (productType?: string | null) =>
	productType
		? (BUNDLE_TYPE_NAMES as readonly string[]).includes(productType)
		: false;

const activeStatusID = 1;

export {
	ItemType,
	Parametrics,
	PageSlugs,
	ComponentsRenderedInModal,
	CategoryUrlParams,
	ProductPrefix,
	ProductTypes,
	BUNDLE_TYPE_NAMES,
	isBundleProductTypeName,
	activeStatusID
};
